module.exports = __webpack_public_path__ + "static/media/game-preview@768.497a5216.png";